var endpointMap = {
	ar: {
		appStrings: "translation-ar.json"
	},
	"ar-AE": {
		appStrings: "translation-ar.json"
	},
	bn: {
		appStrings: "translation-bn.json"
	},
	"bn-IN": {
		appStrings: "translation-bn.json"
	},
	cs: {
		appStrings: "translation-cs.json"
	},
	"cs-CZ": {
		appStrings: "translation-cs.json"
	},
	da: {
		appStrings: "translation-da.json"
	},
	"da-DK": {
		appStrings: "translation-da.json"
	},
	de: {
		appStrings: "translation-de.json"
	},
	"de-DE": {
		appStrings: "translation-de.json"
	},
	en: {
		appStrings: "translation-en.json"
	},
	"en-AE": {
		appStrings: "translation-en.json"
	},
	"en-AU": {
		appStrings: "translation-en.json"
	},
	"en-CA": {
		appStrings: "translation-en.json"
	},
	"en-GB": {
		appStrings: "translation-en.json"
	},
	"en-IE": {
		appStrings: "translation-en.json"
	},
	"en-IN": {
		appStrings: "translation-en.json"
	},
	"en-SG": {
		appStrings: "translation-en.json"
	},
	"en-US": {
		appStrings: "translation-en.json"
	},
	"en-ZA": {
		appStrings: "translation-en.json"
	},
	es: {
		appStrings: "translation-es.json"
	},
	"es-ES": {
		appStrings: "translation-es.json"
	},
	"es-MX": {
		appStrings: "translation-es.json"
	},
	"es-US": {
		appStrings: "translation-es.json"
	},
	fr: {
		appStrings: "translation-fr.json"
	},
	"fr-BE": {
		appStrings: "translation-fr.json"
	},
	"fr-CA": {
		appStrings: "translation-fr.json"
	},
	"fr-FR": {
		appStrings: "translation-fr.json"
	},
	he: {
		appStrings: "translation-he.json"
	},
	"he-IL": {
		appStrings: "translation-he.json"
	},
	hi: {
		appStrings: "translation-hi.json"
	},
	"hi-IN": {
		appStrings: "translation-hi.json"
	},
	it: {
		appStrings: "translation-it.json"
	},
	"it-IT": {
		appStrings: "translation-it.json"
	},
	ja: {
		appStrings: "translation-ja.json"
	},
	"ja-JP": {
		appStrings: "translation-ja.json"
	},
	kn: {
		appStrings: "translation-kn.json"
	},
	"kn-IN": {
		appStrings: "translation-kn.json"
	},
	ko: {
		appStrings: "translation-ko.json"
	},
	"ko-KR": {
		appStrings: "translation-ko.json"
	},
	ml: {
		appStrings: "translation-ml.json"
	},
	"ml-IN": {
		appStrings: "translation-ml.json"
	},
	mr: {
		appStrings: "translation-mr.json"
	},
	"mr-IN": {
		appStrings: "translation-mr.json"
	},
	nl: {
		appStrings: "translation-nl.json"
	},
	"nl-BE": {
		appStrings: "translation-nl.json"
	},
	"nl-NL": {
		appStrings: "translation-nl.json"
	},
	pl: {
		appStrings: "translation-pl.json"
	},
	"pl-PL": {
		appStrings: "translation-pl.json"
	},
	pt: {
		appStrings: "translation-pt.json"
	},
	"pt-BR": {
		appStrings: "translation-pt.json"
	},
	"pt-PT": {
		appStrings: "translation-pt.json"
	},
	sv: {
		appStrings: "translation-sv.json"
	},
	"sv-SE": {
		appStrings: "translation-sv.json"
	},
	ta: {
		appStrings: "translation-ta.json"
	},
	"ta-IN": {
		appStrings: "translation-ta.json"
	},
	te: {
		appStrings: "translation-te.json"
	},
	"te-IN": {
		appStrings: "translation-te.json"
	},
	tr: {
		appStrings: "translation-tr.json"
	},
	"tr-TR": {
		appStrings: "translation-tr.json"
	},
	und: {
		appStrings: "translation.json"
	},
	zh: {
		appStrings: "translation-zh.json"
	},
	"zh-CN": {
		appStrings: "translation-zh.json"
	},
	"zh-TW": {
		appStrings: "translation-zh.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
